import React, { useState, useEffect, useCallback } from "react";
import { useLoading } from "../../../context/LoadingContext";
import DataTable from "../../Requirement/components/common/ReusableTable";
import SearchFilter from "../../Requirement/components/common/SearchFilter";
import { fetchData, postQuery } from "../../../services/BackendServices";
import * as XLSX from "xlsx";
import "../../../styles/general.css";
import "../../../styles/amtpl.css";
import AlertModal from "../../Requirement/components/common/AlerModel";
import {
  FormControl,
  TextField,
  Typography,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import config from "../../../aws-exports";
import { Auth } from "aws-amplify";
import { LambdaClient, InvokeCommand } from "@aws-sdk/client-lambda";
import { debounce } from "lodash";

const Buyer = () => {
  const { setLoading, loading } = useLoading();
  const [errors, setErrors] = useState({});

  // State for Buyers data
  const [amtplBuyers, setAMTPLBuyers] = useState([]);
  const [selectedAMTPLBuyer, setSelectedAMTPLBuyer] = useState(null);
  const [currentAMTPLBuyerPage, setCurrentAMTPLBuyerPage] = useState(1);
  const [totalAMTPLBuyerPages, setTotalAMTPLBuyerPages] = useState(1);

  const bucket = process.env.REACT_APP_AMTPL_BUCKET;
  let bucketfolder = "public/media/amtpl";
  const filePath = `${bucketfolder}/`;
  const fileUrl = `https://${bucket}.s3.${config.aws_project_region}.amazonaws.com/${filePath}`;

  // Filter data
  const [names, setNames] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [locations, setLocations] = useState([]);
  const [zipcodes, setZipcodes] = useState([]);
  const [globalPartners, setGlobalPartners] = useState([]);
  const [countrymaster, setCountryMaster] = useState([]);

  // Filter state
  const [entitiesFilterTerms, setEntitiesFilterTerms] = useState({
    email: "",
    company: "",
    location: "",
    zipcode: "",
    globalPartner: "",
    status: "",
  });

  // Tab state
  const [activeEntitiesBuyerTab, setActiveEntitiesBuyerTab] =
    useState("clientDetails");

  // File upload state
  const [file, setFile] = useState(null);
  const [uploadError, setUploadError] = useState(null);

  // Constants
  const pageSize = 5;

  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  const getBackendName = () => {
    const backend = config.aws_user_files_s3_bucket.split("-");
    return backend[backend.length - 1];
  };

  // Define the status options
  const statusOptions = [
    { value: "", label: "ALL" },
    { value: "ACTIVE", label: "ACTIVE" },
    { value: "INACTIVE", label: "INACTIVE" },
  ];

  // Search fields configuration for SearchFilter component
  const fields = [
    {
      name: "email",
      label: "Name",
      type: "dropdown",
      options: [
        { value: "", label: "Select Name" },
        ...names.map((name) => {
          const match = name.match(/<([^>]+)>/);
          const keyAndValue = match ? match[1].trim() : "";
          return {
            value: keyAndValue,
            label: name,
          };
        }),
      ],
      value: entitiesFilterTerms.email,
      onChange: (value) => {
        setEntitiesFilterTerms((prev) => ({ ...prev, email: value }));
      },
    },
    {
      name: "company",
      label: "Company",
      type: "dropdown",
      options: [
        { value: "", label: "Select Company" },
        ...companies.map((company) => ({
          value: company,
          label: company,
        })),
      ],
      value: entitiesFilterTerms.company,
      onChange: (value) => {
        setEntitiesFilterTerms((prev) => ({ ...prev, company: value }));
      },
    },
    // {
    //   name: "location",
    //   label: "Location",
    //   type: "dropdown",
    //   options: [
    //     { value: "", label: "Select Location" },
    //     ...locations.map((location) => ({
    //       value: location,
    //       label: location,
    //     })),
    //   ],
    //   value: entitiesFilterTerms.location,
    //   onChange: (value) => {
    //     setEntitiesFilterTerms((prev) => ({ ...prev, location: value }));
    //   },
    // },
    {
      name: "zipcode",
      label: "Zipcode",
      type: "dropdown",
      options: [
        { value: "", label: "Select Zipcode" },
        ...zipcodes.map((zipcode) => ({
          value: zipcode,
          label: zipcode,
        })),
      ],
      value: entitiesFilterTerms.zipcode,
      onChange: (value) => {
        setEntitiesFilterTerms((prev) => ({ ...prev, zipcode: value }));
      },
    },
    {
      name: "globalPartner",
      label: "Global Partner",
      type: "dropdown",
      options: [
        { value: "", label: "Select Global Partner" },
        ...globalPartners.map((partner) => ({
          value: partner.value,
          label: partner.label,
        })),
      ],
      value: entitiesFilterTerms.globalPartner,
      onChange: (value) => {
        setEntitiesFilterTerms((prev) => ({ ...prev, globalPartner: value }));
      },
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      options: statusOptions,
      value: entitiesFilterTerms.status,
      onChange: (value) => {
        setEntitiesFilterTerms((prev) => ({ ...prev, status: value }));
      },
    },
  ];

  // Define table columns for DataTable
  const columns = [
    {
      id: "AMTPLUserID",
      numeric: false,
      label: "Client Id",
      renderCell: (row) => row.AMTPLUserID || "N/A",
    },
    {
      id: "ClientName",
      numeric: false,
      label: "Client Name",
      renderCell: (row) =>
        `${row.FirstName || ""} ${row.LastName || ""}`.trim() || "N/A",
    },
    {
      id: "CompanyName",
      numeric: false,
      label: "Company",
      renderCell: (row) => row.CompanyName || "N/A",
    },
    {
      id: "Country",
      numeric: false,
      label: "Country",
      renderCell: (row) => row.Country || "N/A",
    },
    {
      id: "State",
      numeric: false,
      label: "State",
      renderCell: (row) => row.State || "N/A",
    },
    {
      id: "Phone1",
      numeric: false,
      label: "Phone",
      renderCell: (row) => row.Phone1 || "N/A",
    },
    {
      id: "EmailID",
      numeric: false,
      label: "Email",
      renderCell: (row) => row.EmailID || "N/A",
    },
    {
      id: "GPEmailID",
      numeric: false,
      label: "Global Partner",
      renderCell: (row) => {
        const item = globalPartners.find((p) => p.value === row.GPEmailID);
        return item ? item.label : "N/A";
      },
    },
    {
      id: "Status",
      numeric: false,
      label: "Status",
      renderCell: (row) => {
        let bgColor = "";
        let textColor = "";

        switch (row.Status) {
          case "INACTIVE":
            bgColor = "#f85d4f25";
            textColor = "#e2461f";
            break;
          case "ACTIVE":
            bgColor = "#d1fae5";
            textColor = "#065f46";
            break;
          default:
            bgColor = "#f0f0f0";
            textColor = "#000";
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "10px",
              fontWeight: 500,
            }}
          >
            {row.Status || "N/A"}
          </span>
        );
      },
    },
  ];

  // Fetch filter options from all records
  const fetchFilterOptions = useCallback(async () => {
    setLoading(true);
    try {
      const body = {
        target: "listAMTPLUsersAdm",
        option: "buyer",
        filterTerms: {},
        rowStart: 0,
        pageSize: 10000, // Large number to fetch all records
      };

      const result = await fetchData(body);

      if (result && (result.items || result.statusCode === 200)) {
        const buyers = result.items || [];
        if (buyers.length > 0) {
          const uniqueNames = [
            ...new Set(
              buyers
                .map(
                  (p) =>
                    `${p.FirstName || ""} ${p.LastName || ""} <${
                      p.EmailID || ""
                    }>`
                )
                .filter((name) => name.trim() !== "<>")
            ),
          ];
          const uniqueCompanies = [
            ...new Set(buyers.map((p) => p.CompanyName).filter(Boolean)),
          ];
          const uniqueLocations = [
            ...new Set(buyers.map((p) => p.State).filter(Boolean)),
          ];
          const uniqueZipcodes = [
            ...new Set(buyers.map((p) => p.ZipCode).filter(Boolean)),
          ];

          setNames(uniqueNames);
          setCompanies(uniqueCompanies);
          setLocations(uniqueLocations);
          setZipcodes(uniqueZipcodes);
        } else {
          setNames([]);
          setCompanies([]);
          setLocations([]);
          setZipcodes([]);
        }
      } else {
        console.error("Error fetching filter options: ", result);
        setNames([]);
        setCompanies([]);
        setLocations([]);
        setZipcodes([]);
      }
    } catch (error) {
      console.error("Error fetching filter options: ", error);
      setNames([]);
      setCompanies([]);
      setLocations([]);
      setZipcodes([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  // Debounced fetchAMTPLUsers to prevent excessive API calls
  const debouncedFetchAMTPLUsers = useCallback(
    debounce(async (customParams = {}) => {
      setLoading(true);
      try {
        const filterTerms = {
          ...entitiesFilterTerms,
          ...customParams.filterTerms,
        };
        // Remove empty or undefined filter terms
        Object.keys(filterTerms).forEach((key) => {
          if (!filterTerms[key]) delete filterTerms[key];
        });

        const body = {
          target: "listAMTPLUsersAdm",
          option: "buyer",
          filterTerms,
          rowStart:
            customParams.rowStart || (currentAMTPLBuyerPage - 1) * pageSize,
          pageSize: pageSize,
          ...customParams,
        };

        const result = await fetchData(body);

        if (result && (result.items || result.statusCode === 200)) {
          const buyers = result.items || [];
          const modifiedItems = (buyers.items || buyers).map((item) => ({
            ...item,
            id: item.AMTPLUserID, // Add id property with value from RequirementsID
          }));
          setAMTPLBuyers(modifiedItems);
          setTotalAMTPLBuyerPages(
            Math.ceil((result.total || buyers.length) / pageSize)
          );
        } else {
          console.error("Error fetching Buyers: ", result);
          setAMTPLBuyers([]);
          setTotalAMTPLBuyerPages(1);
        }
      } catch (error) {
        console.error("Error fetching Buyers: ", error);
        setAMTPLBuyers([]);
        setTotalAMTPLBuyerPages(1);
      } finally {
        setLoading(false);
      }
    }, 500),
    [currentAMTPLBuyerPage, entitiesFilterTerms, setLoading]
  );

  // Fetch Global Partners for filter
  const fetchGlobalPartners = useCallback(async () => {
    try {
      const result = await fetchData({
        target: "listAMTPLUsersAdm",
        option: "globalpartner",
        filterTerms: {},
        rowStart: 0,
        pageSize: 1000,
      });

      if (result && result.items) {
        const partners = result.items
          .map((p) => ({
            value: p.EmailID,
            label: `${p.FirstName || ""} ${p.LastName || ""} <${
              p.EmailID
            }>`.trim(),
          }))
          .filter((partner) => partner.label !== "<>");
        setGlobalPartners(partners);
      }
    } catch (error) {
      console.error("Error fetching Global Partners: ", error);
    }
  }, []);

  // Event handlers
  const handleFileChange = (event) => {
    console.log("File selected:", event.target.files[0]);
    setFile(event.target.files[0]);
    setUploadError(null);
  };

  const loadCountries = useCallback(async () => {
    setLoading(true);
    try {
      const [allCountries] = await Promise.all([
        fetchData({
          target: "listDropDownOptions",
          userOrder: "Value",
          rowStart: 0,
          pageSize: 1000,
          filterTerms: { Type: "Country" },
        }),
      ]);
      if (allCountries.items.length > 0) {
        setCountryMaster(allCountries.items);
      } else {
        setCountryMaster([]);
      }
    } catch (error) {
      console.error("Error loading countries: ", error);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  // Handle Excel file upload and processing
  const handleUpload = async () => {
    if (!file) {
      setUploadError("Please select a file to upload.");
      return;
    }

    setLoading(true);
    setUploadError(null);

    try {
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          // Parse Excel file
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const parsedData = XLSX.utils.sheet_to_json(sheet);

          console.log("Parsed Excel data:", parsedData);

          if (parsedData.length === 0) {
            setUploadError("The uploaded file is empty.");
            setLoading(false);
            return;
          }

          // Send data to backend
          const body = {
            target: "importAMTPLUsers",
            option: "Buyer",
            usersData: parsedData,
          };

          const result = await postQuery(body, "backendops");

          if (result) {
            console.log("Excel data imported successfully");
            setModal({
              show: true,
              type: "success",
              title: "Success!",
              message: `Excel data imported successfully.`,
              autoClose: false,
              nextAction: () => {
                setFile(null);
                document.getElementById("fileInput").value = "";
              },
            });
            await debouncedFetchAMTPLUsers();
            await fetchFilterOptions(); // Refresh filter options
            await fetchGlobalPartners(); // Refresh global partners
          } else {
            setUploadError("Failed to import data. Please try again.");
            console.error("Error importing Excel data: ", result);
          }
        } catch (error) {
          console.error("Error processing Excel file:", error);
          let errorMessage =
            "An unexpected error occurred while processing the file. Please try again or contact support.";

          try {
            // Handle API response with nested JSON string in body
            console.log("in error try1 block");
            if (error && !error.errors) {
              console.log("in error body block", error.error);
              errorMessage = error.error;
            }
            // Optional: Handle validation errors from backend (like missing Group Name)
            else if (error.errors && Array.isArray(error.errors)) {
              const failedEmails = error.errors
                .map((err) => err.email)
                .join(", ");
              errorMessage = `The following records could not be processed: ${failedEmails}.`;
            }
          } catch (err) {
            console.error("Error processing error response:", err);
            // Keep default message if all parsing fails
          }

          setUploadError(errorMessage);
        } finally {
          setLoading(false);
        }
      };

      reader.onerror = () => {
        setUploadError("Error reading the file. Please try again.");
        setLoading(false);
      };

      reader.readAsArrayBuffer(file);
    } catch (error) {
      setUploadError("Error uploading file. Please try again.");
      console.error("Error uploading file:", error);
      setLoading(false);
    }
  };

  // Handle search for SearchFilter component
  const handleSearchFilter = useCallback(
    (searchValues) => {
      console.log("Search filter values:", searchValues);
      setEntitiesFilterTerms(searchValues);
      setCurrentAMTPLBuyerPage(1); // Reset to first page
      debouncedFetchAMTPLUsers({
        filterTerms: searchValues,
        rowStart: 0,
      });
    },
    [debouncedFetchAMTPLUsers]
  );

  const handlePageChange = (newPage) => {
    setCurrentAMTPLBuyerPage(newPage);
    debouncedFetchAMTPLUsers({
      rowStart: (newPage - 1) * pageSize,
    });
  };

  const handleRowClick = (buyer) => {
    setSelectedAMTPLBuyer(buyer);
  };

  const handleEntitiesBuyerTabClick = (tab) => {
    setActiveEntitiesBuyerTab(tab);
  };

  const handleAMTPLBuyerChange = (event) => {
    const { id, name, value } = event.target;
    const field = id || name;
    setSelectedAMTPLBuyer((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleBuyerSave = async () => {
    if (!selectedAMTPLBuyer) return;

    setLoading(true);
    try {
      let recordStatus = selectedAMTPLBuyer.Status || "INACTIVE";
      const userStatusResponse = await postQuery(
        {
          target: "changeUserStatus",
          Input: {
            userEmailAddress: selectedAMTPLBuyer.EmailID,
            newStatus: recordStatus,
          },
        },
        "backendops"
      );
      const body = {
        target: "updateAMTPLUser",
        updateAMTPLUserInput: {
          AMTPLUserID: selectedAMTPLBuyer.AMTPLUserID,
          EmailID: selectedAMTPLBuyer.EmailID,
          FirstName: selectedAMTPLBuyer.FirstName || "",
          LastName: selectedAMTPLBuyer.LastName || "",
          Country: selectedAMTPLBuyer.Country || "",
          State: selectedAMTPLBuyer.State || "",
          City: selectedAMTPLBuyer.City || "",
          Phone1: selectedAMTPLBuyer.Phone1 || "",
          Phone2: selectedAMTPLBuyer.Phone2 || "",
          Address1: selectedAMTPLBuyer.Address1 || "",
          Address2: selectedAMTPLBuyer.Address2 || "",
          ZipCode: selectedAMTPLBuyer.ZipCode || "",
          CompanyName: selectedAMTPLBuyer.CompanyName || "",
          CompanyZipCode: selectedAMTPLBuyer.CompanyZipCode || "",
          CompanyPhone1: selectedAMTPLBuyer.CompanyPhone1 || "",
          CompanyPhone2: selectedAMTPLBuyer.CompanyPhone2 || "",
          CompanyPhone3: selectedAMTPLBuyer.CompanyPhone3 || "",
          CompanyPhone4: selectedAMTPLBuyer.CompanyPhone4 || "",
          CompanyAddress1: selectedAMTPLBuyer.CompanyAddress1 || "",
          CompanyAddress2: selectedAMTPLBuyer.CompanyAddress2 || "",
          CompanyAddress3: selectedAMTPLBuyer.CompanyAddress3 || "",
          CompanyCity: selectedAMTPLBuyer.CompanyCity || "",
          CompanyCountry: selectedAMTPLBuyer.CompanyCountry || "",
          CompanyEmail: selectedAMTPLBuyer.CompanyEmail || "",
          CompanyState: selectedAMTPLBuyer.CompanyState || "",
          Age: selectedAMTPLBuyer.Age || 0,
          Gender: selectedAMTPLBuyer.Gender || "",
          CompanyLinkedIn: selectedAMTPLBuyer.CompanyLinkedIn || "",
          CompanyTwitter: selectedAMTPLBuyer.CompanyTwitter || "",
          CompanyWebsite: selectedAMTPLBuyer.CompanyWebsite || "",
          LinkedIn: selectedAMTPLBuyer.LinkedIn || "",
          Twitter: selectedAMTPLBuyer.Twitter || "",
          Status: recordStatus,
        },
      };
      const result = await postQuery(body);

      if (result) {
        console.log("Buyer updated successfully");
        setModal({
          show: true,
          type: "success",
          title: "Success!",
          message: `Buyer updated successfully.`,
          autoClose: false,
          nextAction: () => {
            setFile(null);
            document.getElementById("fileInput").value = "";
          },
        });
        await debouncedFetchAMTPLUsers();
        await fetchFilterOptions(); // Refresh filter options
      } else {
        console.error("Error updating buyer: ", result);
        setModal({
          show: true,
          type: "error",
          title: "Error!",
          message: "Error happened updating Buyer.",
          autoClose: false,
        });
      }
    } catch (error) {
      console.error("Error updating buyer: ", error);
      setModal({
        show: true,
        type: "error",
        title: "Error!",
        message: error.message || "Error updating Buyer.",
        autoClose: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const resetPassword = async (selectedAMTPLUser) => {
    if (!selectedAMTPLUser) {
      console.error("No user selected");
      return;
    }

    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      const body = {
        target: "activate_amtpluser",
        option: "buyer",
        access_token: user.signInUserSession.idToken.jwtToken,
        amtplUser: selectedAMTPLUser,
      };

      const params = {
        FunctionName: `backendops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));

      if (result.statusCode === 200) {
        console.log(`Save action successful`, result);
        const bodyAMTPLUser = {
          target: "updateAMTPLUser",
          updateAMTPLUserInput: {
            AMTPLUserID: selectedAMTPLBuyer.AMTPLUserID,
            EmailID: selectedAMTPLBuyer.EmailID,
            FirstName: selectedAMTPLBuyer.FirstName || "",
            LastName: selectedAMTPLBuyer.LastName || "",
            Country: selectedAMTPLBuyer.Country || "",
            State: selectedAMTPLBuyer.State || "",
            City: selectedAMTPLBuyer.City || "",
            Phone1: selectedAMTPLBuyer.Phone1 || "",
            Phone2: selectedAMTPLBuyer.Phone2 || "",
            Address1: selectedAMTPLBuyer.Address1 || "",
            Address2: selectedAMTPLBuyer.Address2 || "",
            ZipCode: selectedAMTPLBuyer.ZipCode || "",
            CompanyName: selectedAMTPLBuyer.CompanyName || "",
            CompanyZipCode: selectedAMTPLBuyer.CompanyZipCode || "",
            CompanyPhone1: selectedAMTPLBuyer.CompanyPhone1 || "",
            CompanyPhone2: selectedAMTPLBuyer.CompanyPhone2 || "",
            CompanyPhone3: selectedAMTPLBuyer.CompanyPhone3 || "",
            CompanyPhone4: selectedAMTPLBuyer.CompanyPhone4 || "",
            CompanyAddress1: selectedAMTPLBuyer.CompanyAddress1 || "",
            CompanyAddress2: selectedAMTPLBuyer.CompanyAddress2 || "",
            CompanyAddress3: selectedAMTPLBuyer.CompanyAddress3 || "",
            CompanyCity: selectedAMTPLBuyer.CompanyCity || "",
            CompanyCountry: selectedAMTPLBuyer.CompanyCountry || "",
            CompanyEmail: selectedAMTPLBuyer.CompanyEmail || "",
            CompanyState: selectedAMTPLBuyer.CompanyState || "",
            Age: selectedAMTPLBuyer.Age || 0,
            Gender: selectedAMTPLBuyer.Gender || "",
            CompanyLinkedIn: selectedAMTPLBuyer.CompanyLinkedIn || "",
            CompanyTwitter: selectedAMTPLBuyer.CompanyTwitter || "",
            CompanyWebsite: selectedAMTPLBuyer.CompanyWebsite || "",
            LinkedIn: selectedAMTPLBuyer.LinkedIn || "",
            Twitter: selectedAMTPLBuyer.Twitter || "",
            Status: "ACTIVE",
          },
        };
        const resultAMTPLUser = await postQuery(bodyAMTPLUser);

        if (resultAMTPLUser) {
          console.log("Buyer updated successfully");
          setModal({
            show: true,
            type: "success",
            title: "Success!",
            message: `Buyer activated successfully. Password mail has been sent to registered email.`,
            autoClose: false,
            nextAction: () => {
              setFile(null);
              document.getElementById("fileInput").value = "";
            },
          });
          await debouncedFetchAMTPLUsers();
          await fetchFilterOptions(); // Refresh filter options
        } else {
          console.error("Error updating Buyer");
          setModal({
            show: true,
            type: "error",
            title: "Error!",
            message: "Error happened updating Buyer.",
            autoClose: false,
          });
        }
      } else {
        console.error(`Error updating User: ${JSON.stringify(result)}`);
        setModal({
          show: true,
          type: "error",
          title: "Error!",
          message: `Error updating User: ${JSON.stringify(result)}`,
          autoClose: false,
        });
      }
    } catch (error) {
      console.error(`Error updating User: ${JSON.stringify(error)}`);
      setModal({
        show: true,
        type: "error",
        title: "Error!",
        message: `Error updating User: ${JSON.stringify(error)}`,
        autoClose: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleBuyerResetPassword = async () => {
    resetPassword(selectedAMTPLBuyer);
  };

  // Effects
  useEffect(() => {
    fetchFilterOptions();
    loadCountries();
    fetchGlobalPartners();
  }, [fetchFilterOptions, loadCountries, fetchGlobalPartners]);

  useEffect(() => {
    debouncedFetchAMTPLUsers();
  }, [debouncedFetchAMTPLUsers]);

  const CustomButton = ({ label, onClick, disabled }) => {
    return (
      <button className="submit-btn-more" onClick={onClick} disabled={disabled}>
        {label}
      </button>
    );
  };

  return (
    <div className="buyer-dashboard">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div className="card">
        <div className="row">
          <div className="col-12">
            <div className="card p-4">
              <h4 className="text-center mb-3">Import Data</h4>
              <div className="alert alert-info mb-4 text-center" role="alert">
                To ensure a smooth import, please download our sample format
                first. This will help you structure your data correctly.
              </div>
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="text-center">
                  <a
                    href={`${fileUrl}sampleformat/SampleFormatBuyer.xlsx`}
                    className="btn btn-primary"
                  >
                    Download Sample Format
                  </a>
                  <small className="text-muted d-block mt-1">
                    (.xlsx format)
                  </small>
                </div>
                <div className="text-center">
                  <label
                    htmlFor="fileInput"
                    className="submit-btn"
                    style={{ border: "dashed 1px #ccc", minWidth: "180px" }}
                  >
                    Upload Your File
                  </label>
                  <input
                    type="file"
                    id="fileInput"
                    onChange={handleFileChange}
                    accept=".csv,.xlsx,.xls"
                    className="d-none"
                  />
                  {file && <span className="ml-2">{file.name}</span>}
                  {uploadError && (
                    <div className="text-danger mt-2 small">{uploadError}</div>
                  )}
                </div>
                <div className="text-center">
                  <CustomButton
                    label="Import"
                    onClick={handleUpload}
                    disabled={!file}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="search-filter4">
          <div className="title4">
            <div className="head-text">Buyer</div>
          </div>
          <div className="filter4">
            <SearchFilter fields={fields} onSearch={handleSearchFilter} />
          </div>
        </div>

        {loading && (
          <div className="loading text-center text-gray-500">
            Loading Buyers...
          </div>
        )}

        {!loading && amtplBuyers.length > 0 && (
          <DataTable
            columns={columns}
            data={amtplBuyers}
            total={totalAMTPLBuyerPages * pageSize}
            title="Buyer Information"
            rowsPerPage={pageSize}
            onPageChange={handlePageChange}
            onRowClick={handleRowClick}
            currentPage={currentAMTPLBuyerPage}
            selectedRows={selectedAMTPLBuyer ? [selectedAMTPLBuyer.id] : []}
          />
        )}

        {!loading && amtplBuyers.length === 0 && (
          <div className="text-center p-4">
            <p>No Buyers available</p>
          </div>
        )}

        {selectedAMTPLBuyer && (
          <div className="mt-4">
            <div className="button-group">
              <CustomButton
                label="Update"
                onClick={handleBuyerSave}
                disabled={!selectedAMTPLBuyer}
              />
              <CustomButton
                label="Generate & Send Password"
                onClick={handleBuyerResetPassword}
                disabled={!selectedAMTPLBuyer}
              />
            </div>
            <section>
              <div className="tabs">
                <button
                  className={
                    activeEntitiesBuyerTab === "clientDetails" ? "active" : ""
                  }
                  onClick={() => handleEntitiesBuyerTabClick("clientDetails")}
                >
                  Client Details
                </button>
                <button
                  className={
                    activeEntitiesBuyerTab === "companyDetails" ? "active" : ""
                  }
                  onClick={() => handleEntitiesBuyerTabClick("companyDetails")}
                >
                  Company Details
                </button>
              </div>

              {activeEntitiesBuyerTab === "clientDetails" && (
                <div className="tab-content active">
                  <div className="row">
                    <div className="col-lg-12 col-sm-12 col-12">
                      <div className="row">
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="FirstName">First Name</label>
                          <input
                            id="FirstName"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.FirstName || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="LastName">Last Name</label>
                          <input
                            id="LastName"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.LastName || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="Age">Age</label>
                          <input
                            id="Age"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.Age || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <FormControl
                            sx={{ minWidth: "100%" }}
                            error={!!errors.Gender}
                          >
                            <Typography variant="body2">Gender</Typography>
                            <Select
                              name="Gender"
                              value={selectedAMTPLBuyer?.Gender || ""}
                              onChange={handleAMTPLBuyerChange}
                              displayEmpty
                              sx={{ backgroundColor: "white" }}
                              inputProps={{ "aria-label": "Select Gender" }}
                              error={!!errors.Gender}
                            >
                              <MenuItem value="" disabled>
                                Select gender
                              </MenuItem>
                              <MenuItem value="M">Male</MenuItem>
                              <MenuItem value="F">Female</MenuItem>
                              <MenuItem value="O">Other</MenuItem>
                            </Select>
                            {errors.Gender && (
                              <Typography variant="caption" color="error">
                                {errors.Gender}
                              </Typography>
                            )}
                          </FormControl>
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="Phone1">Phone 1</label>
                          <input
                            id="Phone1"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.Phone1 || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="Phone2">Phone 2</label>
                          <input
                            id="Phone2"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.Phone2 || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="EmailID">Email</label>
                          <input
                            id="EmailID"
                            type="text"
                            readOnly
                            className="form-control"
                            value={selectedAMTPLBuyer?.EmailID || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="LinkedIn">LinkedIn</label>
                          <input
                            id="LinkedIn"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.LinkedIn || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="Twitter">Twitter</label>
                          <input
                            id="Twitter"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.Twitter || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="Website">Website</label>
                          <input
                            id="Website"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.Website || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <FormControl
                            sx={{ minWidth: "100%" }}
                            error={!!errors.Country}
                          >
                            <Typography variant="body2">Country</Typography>
                            <Select
                              name="Country"
                              value={selectedAMTPLBuyer?.Country || ""}
                              onChange={handleAMTPLBuyerChange}
                              displayEmpty
                              sx={{ backgroundColor: "white" }}
                              inputProps={{ "aria-label": "Select Country" }}
                              error={!!errors.Country}
                            >
                              <MenuItem value="" disabled>
                                Select country
                              </MenuItem>
                              {countrymaster.map((p) => (
                                <MenuItem key={p.ID} value={p.Value}>
                                  {p.Value}
                                </MenuItem>
                              ))}
                            </Select>
                            {errors.Country && (
                              <Typography variant="caption" color="error">
                                {errors.Country}
                              </Typography>
                            )}
                          </FormControl>
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="State">State</label>
                          <input
                            id="State"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.State || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="Address1">Address</label>
                          <input
                            id="Address1"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.Address1 || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="ZipCode">PIN/ ZIP</label>
                          <input
                            id="ZipCode"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.ZipCode || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-md-3">
                          <FormControl
                            sx={{ minWidth: "100%" }}
                            error={!!errors.Status}
                          >
                            <Typography variant="body2">Status</Typography>
                            <Select
                              name="Status"
                              value={selectedAMTPLBuyer?.Status || ""}
                              onChange={handleAMTPLBuyerChange}
                              displayEmpty
                              sx={{ backgroundColor: "white" }}
                              inputProps={{
                                "aria-label": "Select Status",
                              }}
                            >
                              <MenuItem value="" disabled>
                                Select Status
                              </MenuItem>
                              <MenuItem value="ACTIVE">ACTIVE</MenuItem>
                              <MenuItem value="INACTIVE">INACTIVE</MenuItem>
                            </Select>
                            {errors.Status && (
                              <Typography variant="caption" color="error">
                                {errors.Status}
                              </Typography>
                            )}
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeEntitiesBuyerTab === "companyDetails" && (
                <div className="tab-content active">
                  <div className="row">
                    <div className="col-lg-12 col-sm-12 col-12">
                      <div className="row">
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="CompanyName">Co Name</label>
                          <input
                            id="CompanyName"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.CompanyName || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="CompanyWebsite">Website</label>
                          <input
                            id="CompanyWebsite"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.CompanyWebsite || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="CompanyEmail">Email</label>
                          <input
                            id="CompanyEmail"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.CompanyEmail || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <FormControl
                            sx={{ minWidth: "100%" }}
                            error={!!errors.CompanyCountry}
                          >
                            <Typography variant="body2">Country</Typography>
                            <Select
                              name="CompanyCountry"
                              value={selectedAMTPLBuyer?.CompanyCountry || ""}
                              onChange={handleAMTPLBuyerChange}
                              displayEmpty
                              sx={{ backgroundColor: "white" }}
                              inputProps={{ "aria-label": "Select Country" }}
                              error={!!errors.CompanyCountry}
                            >
                              <MenuItem value="" disabled>
                                Select country
                              </MenuItem>
                              {countrymaster.map((p) => (
                                <MenuItem key={p.ID} value={p.Value}>
                                  {p.Value}
                                </MenuItem>
                              ))}
                            </Select>
                            {errors.CompanyCountry && (
                              <Typography variant="caption" color="error">
                                {errors.CompanyCountry}
                              </Typography>
                            )}
                          </FormControl>
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="CompanyState">State</label>
                          <input
                            id="CompanyState"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.CompanyState || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="CompanyAddress1">Address</label>
                          <input
                            id="CompanyAddress1"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.CompanyAddress1 || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="CompanyZipCode">PIN/ ZIP</label>
                          <input
                            id="CompanyZipCode"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.CompanyZipCode || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="CompanyLinkedIn">LinkedIn</label>
                          <input
                            id="CompanyLinkedIn"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.CompanyLinkedIn || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="CompanyTwitter">Twitter</label>
                          <input
                            id="CompanyTwitter"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.CompanyTwitter || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="CompanyWebsite">Website</label>
                          <input
                            id="CompanyWebsite"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.CompanyWebsite || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="CompanyPhone1">Phone 1</label>
                          <input
                            id="CompanyPhone1"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.CompanyPhone1 || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="CompanyPhone2">Phone 2</label>
                          <input
                            id="CompanyPhone2"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.CompanyPhone2 || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="CompanyPhone3">Phone 3</label>
                          <input
                            id="CompanyPhone3"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.CompanyPhone3 || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="CompanyPhone4">Phone 4</label>
                          <input
                            id="CompanyPhone4"
                            type="text"
                            className="form-control"
                            value={selectedAMTPLBuyer?.CompanyPhone4 || ""}
                            onChange={handleAMTPLBuyerChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </section>
          </div>
        )}
      </div>
    </div>
  );
};

export default Buyer;
